export const WEEK_DAYS_SHORT = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

/**
 * Key used to store a time slot in `Schedule.hours`.
 * A schedule can hold several slots at the same time (for example one per bucket),
 * so the time alone is not unique - the slot ids and bucket disambiguate them
 * (ids alone can collide when several same-time slots have no content yet).
 */
export function scheduleTimeKey(slot: { time: string, ids: string[], postBucketId?: string }) {
  return `${slot.time}#${slot.ids.join(',')}#${slot.postBucketId ?? ''}`
}
